module.exports = __webpack_public_path__ + "catalog/items/school-desk/school-desk.png";